// This (ugly) function checks for a specific convention on
// the `class` attributes and adds an `id` attribute when needed.
// The convention is that when a tag has `class="id-<something>"`
// then `id="something"` is added to it.
export function addIdAttributes(html) {
  return html.replace(/class="id-([^"]+)"/g, 'class="id-$1" id="$1"')
}
